<template>
  <div class="activity">
    <!-- banner -->
    <Banner />
    <!-- 套餐 -->
    <PackageInfo
      :bundle-list="bundleData"
      @rushBuy="handleRushBuy"
      @changeActiveCardType="handleChangeActiveCardType" />
    <!-- 服务项 -->
    <ServiceItems v-show="cardType === 'USLC'" />
    <!-- 如何参与活动 -->
    <HowPart id="HowPart" />
    <!-- 疑虑 -->
    <Doubt :cardType="cardType" />
    <!-- 悬浮图标 -->
    <div class="suspension" @click="handleClick">
      <img src="@/assets/images/visa/suspension.png" alt="" />
    </div>
  </div>
</template>
<script>
// 组件
import Banner from './components/Banner';
import PackageInfo from './components/PackageInfo';
import ServiceItems from './components/ServiceItems';
import HowPart from './components/HowPart.vue';
import Doubt from './components/Doubt';
// 引入api
import { bundleList } from '@/api/bundle';
export default {
  beforeRouteEnter(to, from, next) {
    document.title = 'VISA与迎客联合活动'; // 使用路由 meta 中的 title
    next();
  },
  components: {
    Banner,
    PackageInfo,
    ServiceItems,
    HowPart,
    Doubt
  },
  data() {
    return {
      bundleData: [],
      cardType: 'USLC'
    };
  },
  created() {
    this.bundleList();
  },

  async mounted() {
    this.$setPoint('AC_10013', 1);
  },

  methods: {
    /**
     * @description 获取套餐列表
     * @param {Array} positions 美国卡 全球实体卡 全球eSIM
     * @returns 500mb美国卡不参与活动
     */
    async bundleList() {
      const res = await bundleList({
        positions: ['rk-index-uslc-main', 'rk-index-grdc-psim', 'rk-index-grdc-esim']
      });
      if (res.code === '200') {
        this.bundleData = res.data.map((item) => {
          if (item.position === 'rk-index-uslc-main') {
            return {
              ...item,
              dataGroups: ['无限量', '15GB', '5GB', '2GB'],
              groups: ['3', '6', '12'],
              productList: item.productList
                .filter((v) => v.bundleData !== '500MB')
                .map((v) => {
                  return {
                    ...v, // 保留 v 中已有的属性
                    esimType: 0 // 0实体卡 1esim卡
                  };
                })
            };
          } else {
            if (item.position === 'rk-index-grdc-psim') {
              return {
                ...item,
                productList: item.productList.map((v) => {
                  return {
                    ...v,
                    esimType: 0
                  };
                })
              };
            }
            if (item.position === 'rk-index-grdc-esim') {
              return {
                ...item,
                productList: item.productList.map((v) => {
                  return {
                    ...v,
                    esimType: 1
                  };
                })
              };
            }
          }
        });
      }
    },
    handleChangeActiveCardType(val) {
      this.cardType = val;
    },
    handleRushBuy(data) {
      this.$refs.IccidCheck.propsInit(data);
    },
    handleClick() {
      document.getElementById('HowPart').scrollIntoView({
        behavior: 'smooth' // 添加平滑滚动效果
      });
    }
  }
};
</script>

<style lang="less" scoped>
.activity {
  background: #f5fcfb;
  min-width: 1200px;
  ::v-deep .my-title {
    font-weight: 600;
    display: flex;
    justify-content: center;
    position: relative;
    margin-bottom: 40px;

    div {
      color: #333;
      font-family: OPPOSans;
      font-size: 35px;
      font-style: normal;
      font-weight: 800;
      line-height: 64px;
      position: relative;
      background: url(~@/assets/images/visa/icon-h3.svg) no-repeat left center;
    }

    strong {
      color: #ff4d14;
      font-family: OPPOSans;
      font-size: 35px;
      font-style: normal;
      font-weight: 800;
      line-height: 64px;
      position: relative;
    }
  }
  .suspension {
    position: fixed;
    right: 0px;
    top: 400px;
    z-index: 1000;
    img {
      width: 152px;
      height: 140px;
    }
  }
}

@media (max-width: 767px) {
  .activity {
    min-width: 100vw;
    background: #f5fcfb;
    position: relative;
    ::v-deep .my-title {
      margin-bottom: 7.4667vw;
      span {
        color: #333;
        font-family: OPPOSans;
        font-size: 5.3333vw;
        font-style: normal;
        font-weight: 400;
        line-height: 8.5333vw; /* 160% */
      }
      strong {
        color: #c9161d;
        font-family: OPPOSans;
        font-size: 5.3333vw;
        font-style: normal;
        font-weight: 400;
        line-height: 8.5333vw;
      }
    }
    .suspension {
      position: fixed;
      right: 0px;
      top: 60vw;
      img {
        width: 20.2667vw;
        height: 18.6667vw;
      }
    }
  }
}
</style>
